var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class AnnotationCSVExporter {
    /**
     * Convert positions from Vector3
     *
     * @param positions
     */
    convertPositions(positions) {
        return positions.map((point) => [point.x, point.y, point.z]);
    }
    /**
     * Transform urls
     *
     * @param urls
     */
    transformUrlValues(urls) {
        return ('[' + urls.map(({ name, url }) => `[${name}, ${url}]`).join(',') + ']');
    }
    /**
     * Get field columns
     *
     * @param fields
     */
    getFieldColumns(fields) {
        const fieldObj = {};
        for (const field of fields) {
            if (field.type === 'URL' && field.urls) {
                fieldObj[`${field.name} (${field.type})`] = this.transformUrlValues(field.urls);
            }
            else if (field.type === 'FILE' && field.files) {
                fieldObj[`${field.name} (${field.type})`] = this.transformUrlValues(field.files);
            }
            else if ('value' in field)
                fieldObj[`${field.name} (${field.type})`] = field.value;
        }
        return fieldObj;
    }
    /**
     * Convert JSON to CSV
     *
     * @param jsonData
     */
    jsonToCsv(jsonData) {
        let csv = '';
        // Extracting headers from the first object in JSON
        const headers = Object.keys(jsonData);
        // Joining headers with comma
        csv += headers.join(',') + '\n';
        // Extracting values for each header
        const values = headers.map((header) => {
            let value = jsonData[header];
            // Checking if the value is a string and if it contains comma, surround it with double quotes
            if (typeof value === 'string' && value.includes(',')) {
                value = `"${value}"`;
            }
            return value;
        });
        // Joining values with comma
        csv += values.join(',') + '\n';
        return csv;
    }
    /**
     * Get the list of CSVs
     *
     * @param annotations
     */
    read(annotations) {
        return __awaiter(this, void 0, void 0, function* () {
            const csvFiles = [];
            for (const annotation of annotations) {
                const fieldInfo = this.getFieldColumns(annotation.fields);
                const points = this.convertPositions(annotation.annotation3d.positions);
                const annotationInfo = {
                    Name: annotation.name,
                    Color: annotation.color,
                    '3D Shape': annotation.annotation3d.shapeType,
                    '3D Points': JSON.stringify(points),
                };
                const csv = this.jsonToCsv(Object.assign(Object.assign({}, annotationInfo), fieldInfo));
                csvFiles.push(csv);
            }
            return csvFiles;
        });
    }
}
export default AnnotationCSVExporter;
